/*
  Alle henvendelser fra sitets formularer sendes til lead-backenden dms-leads (/lead)
  i stedet for Shopifys /contact. Backend mailer info@dms.as via Leadmagneten Send (Resend,
  svar-til = kunden), opretter et Trello-kort med label i "Nye leads" og gemmer en blob-kopi.

  - window.dmsSendLead(form, label?, formData?) → Promise. Bruges af popup-formularerne
    (forespørgsel, demo-booking, udlejning, produkt-CTA) i stedet for fetch(form.action).
  - Øvrige formularer med form_type=contact (kontaktsiden, popups, produktinfo) fanges her
    i capture-fasen på window — før Shopifys captcha-script på document — så native submit til
    /contact stoppes. Data sendes til backend, og formularen erstattes af en kvittering.
    Popup-formularerne med eget script (CUSTOM_FORMS) springes over; de kalder dmsSendLead selv,
    og demo-kalenderens validering når at køre først.
  - Label (kortets præfiks + Trello-label) vælges ud fra formularen, eller data-dms-lead-label.
*/
(function () {
  if (window.dmsSendLead) return;

  var ENDPOINT = "https://dms-leads.vercel.app/lead";
  var SKIP_FIELDS = ["form_type", "utf8", "authenticity_token", "recaptcha-v3-token", "h-captcha-response", "g-recaptcha-response"];
  // Formularer med eget submit-script (id-præfiks før evt. "-uid")
  var CUSTOM_FORMS = ["inquiryForm", "demoForm", "rentalForm"];
  var LABELS = {
    inquiryForm: "Forespørgsel",
    demoForm: "Demo-booking",
    rentalForm: "Udlejning",
    ContactForm: "Kontakt",
    EventPopupForm: "Popup",
  };

  function labelFor(form) {
    if (form.dataset.dmsLeadLabel) return form.dataset.dmsLeadLabel;
    var base = (form.id || "").replace(/-.*$/, "");
    if (LABELS[base]) return LABELS[base];
    var cls = form.className || "";
    if (/flexi-contact-form/.test(cls)) return "Kontakt";
    if (/popup-overlay/.test(cls)) return "Popup";
    if (/product-signup|request-information/.test(cls) || form.closest(".product-info-wrap-content")) return "Produktinfo";
    return "Kontakt";
  }

  function collect(formData) {
    var fields = {};
    formData.forEach(function (value, key) {
      if (SKIP_FIELDS.indexOf(key) !== -1 || typeof value !== "string") return;
      if (value.trim()) fields[key] = value.trim();
    });
    return fields;
  }

  function hasContact(fields) {
    return Object.keys(fields).some(function (k) {
      return /email|phone|telefon/i.test(k);
    });
  }

  window.dmsSendLead = function (form, label, formData) {
    var fields = collect(formData || new FormData(form));
    var payload = {
      source: "site-form:" + (form.id || form.className || "ukendt").toString().slice(0, 60),
      label: label || labelFor(form),
      page: window.location.href,
      fields: fields,
    };
    if (form.dataset.dmsLeadSource) payload.source = form.dataset.dmsLeadSource;
    return fetch(ENDPOINT, {
      method: "POST",
      // text/plain = ingen CORS-preflight
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then(function (r) {
      if (!r.ok) throw new Error("Lead-endpoint svarede " + r.status);
      return r.json().catch(function () { return { ok: true }; });
    });
  };

  function esc(v) {
    return String(v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function val(form, re) {
    var el = Array.prototype.find.call(form.elements, function (e) {
      return e.name && re.test(e.name) && e.value && e.value.trim();
    });
    return el ? el.value.trim() : "";
  }

  /*
    Officiel bekræftelse efter afsendelse: erstatter formularen med en kvittering.
    opts: { title, lead, details: [[label, value]], steps: [tekst], onClose }
    Uden details hentes navn/e-mail/telefon fra formularen.
  */
  window.dmsShowConfirmation = function (form, opts) {
    opts = opts || {};
    var details = opts.details || [];
    var name = val(form, /\[(name|fornavn)\]/i);
    var last = val(form, /\[efternavn\]/i);
    if (name) details.push(["Navn", last ? name + " " + last : name]);
    var email = val(form, /e-?mail/i);
    if (email) details.push(["E-mail", email]);
    var phone = val(form, /phone|telefon/i);
    if (phone) details.push(["Telefon", phone]);
    var steps = opts.steps || ["Vi gennemgår din henvendelse.", "En medarbejder kontakter dig hurtigst muligt på telefon eller e-mail."];

    var old = form.parentNode.querySelector(".dms-confirm");
    if (old) old.remove();
    var box = document.createElement("div");
    box.className = "dms-confirm";
    box.setAttribute("role", "status");
    box.innerHTML =
      '<span class="dms-confirm-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12.5 10 17.5 19 7"/></svg></span>' +
      '<h3 class="dms-confirm-title" tabindex="-1">' + esc(opts.title || "Tak for din henvendelse") + "</h3>" +
      '<p class="dms-confirm-lead">' + esc(opts.lead || "Vi har modtaget din henvendelse.") + "</p>" +
      (details.length
        ? '<dl class="dms-confirm-details">' +
          details.map(function (d) { return "<div><dt>" + esc(d[0]) + "</dt><dd>" + esc(d[1]) + "</dd></div>"; }).join("") +
          "</dl>"
        : "") +
      '<p class="dms-confirm-next-title">Hvad sker der nu?</p>' +
      '<ol class="dms-confirm-steps">' + steps.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ol>" +
      '<p class="dms-confirm-contact">Har du spørgsmål i mellemtiden? Ring på <a href="tel:70223700">70 22 37 00</a> eller skriv til <a href="mailto:info@dms.as">info@dms.as</a>.</p>' +
      (opts.onClose ? '<button type="button" class="dms-confirm-close">Luk</button>' : "");

    form.style.display = "none";
    form.insertAdjacentElement("afterend", box);
    var scroller = box.closest(".dms-modal, [class*='modal']");
    if (scroller) scroller.scrollTop = 0;
    var title = box.querySelector(".dms-confirm-title");
    if (title) title.focus({ preventScroll: !scroller ? false : true });

    if (opts.onClose) {
      box.querySelector(".dms-confirm-close").addEventListener("click", function () {
        opts.onClose();
      });
    }
    // Nulstil, så formularen er klar igen næste gang popup'en åbnes
    return function reset() {
      box.remove();
      form.reset();
      form.style.display = "";
    };
  };

  window.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || form.tagName !== "FORM" || event.defaultPrevented) return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== "contact") return;
    if (CUSTOM_FORMS.indexOf((form.id || "").replace(/-.*$/, "")) !== -1) return;
    if (form.classList.contains("pp-inquiry-form") || form.dataset.dmsLead === "custom") return;

    var formData = new FormData(form);
    if (!hasContact(collect(formData))) return;

    event.preventDefault();
    // Stop Shopifys captcha-script i at lave en native submit til /contact
    event.stopImmediatePropagation();

    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    var error = form.querySelector(".dms-lead-error");
    if (error) error.remove();

    window.dmsSendLead(form, null, formData).then(
      function () {
        window.dmsShowConfirmation(form, {
          title: "Tak for din henvendelse",
          lead: "Vi har modtaget din besked og vender tilbage hurtigst muligt.",
        });
        form.reset();
      },
      function () {
        if (button) button.disabled = false;
        var p = document.createElement("p");
        p.className = "dms-lead-error";
        p.setAttribute("role", "alert");
        p.innerHTML = 'Beskeden kunne ikke sendes. Prøv igen, eller ring på <a href="tel:70223700">70 22 37 00</a>.';
        (button || form.lastElementChild).insertAdjacentElement("afterend", p);
      },
    );
  }, true);
})();
